import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/back.svg'
import _imports_1 from '@/assets/images/up.svg'
import _imports_2 from '@/assets/images/down.svg'
import _imports_3 from '@/assets/images/pause.svg'
import _imports_4 from '@/assets/images/play.svg'
import _imports_5 from '@/assets/images/stop.svg'


const _withScopeId = n => (_pushScopeId("data-v-12d079f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "timer" }
const _hoisted_2 = { class: "back-button" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "picto back",
  src: _imports_0
}, null, -1))
const _hoisted_4 = { class: "timer-information-update" }
const _hoisted_5 = { class: "timer-information" }
const _hoisted_6 = { class: "timer-update" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "spartan-font text-base" }, "Suggested time", -1))
const _hoisted_8 = { class: "buttons" }
const _hoisted_9 = { class: "timer-action" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CircleProgress = _resolveComponent("CircleProgress")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "spartan-font text-base",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.returnToSelection && _ctx.returnToSelection(...args)))
      }, [
        _hoisted_3,
        _createTextVNode("Return to selection history ")
      ])
    ]),
    _createElementVNode("h2", {
      class: "spartan-font text-lg",
      style: _normalizeStyle({ color: _ctx.colors.primary })
    }, _toDisplayString(_ctx.timerType) + " time ", 5),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", {
          class: "spartan-font text-xxl time",
          style: _normalizeStyle({ color: _ctx.colors.primary })
        }, _toDisplayString(_ctx.formattedDurationLeft), 5),
        _createVNode(_component_CircleProgress, {
          size: _ctx.circleSize,
          "border-width": 6,
          "border-bg-width": 2,
          percent: _ctx.percentLeft,
          "fill-color": _ctx.colors.primary,
          "empty-color": _ctx.colors.secondary,
          transition: 1000
        }, null, 8, ["size", "percent", "fill-color", "empty-color"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("img", {
          class: "blue-border img-button",
          alt: "up button",
          src: _imports_1,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.increaseTime(300)))
        }),
        _createElementVNode("img", {
          class: "red-border img-button",
          alt: "down button",
          src: _imports_2,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.decreaseTime(300)))
        })
      ])
    ]),
    (_ctx.durationIsOver)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["suggested-time", [_ctx.timerType === 'study' ? 'blue' : 'red']])
        }, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              class: "spartan-font text-base",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.increaseTime(3600)))
            }, " 60:00 "),
            _createElementVNode("button", {
              class: "spartan-font text-base",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.increaseTime(2400)))
            }, " 40:00 "),
            _createElementVNode("button", {
              class: "spartan-font text-base",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.increaseTime(1800)))
            }, " 30:00 "),
            _createElementVNode("button", {
              class: "spartan-font text-base",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.increaseTime(1200)))
            }, " 20:00 ")
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.isPlaying)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "blue-border img-button",
            alt: "pause button",
            src: _imports_3,
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.pauseTimer && _ctx.pauseTimer(...args)))
          }))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            style: _normalizeStyle([
          _ctx.durationLeft > 0
            ? { opacity: 1, cursor: 'pointer' }
            : { opacity: 0.5, cursor: 'not-allowed' }
        ]),
            class: "blue-border img-button",
            alt: "play button",
            src: _imports_4,
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.startTimer && _ctx.startTimer(...args)))
          }, null, 4)),
      _createElementVNode("img", {
        class: "red-border img-button",
        alt: "stop button",
        src: _imports_5,
        onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.endTimer && _ctx.endTimer(...args)))
      })
    ])
  ]))
}